import React from 'react'
import Head from 'next/head'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import AppUrlLib from '@libs/appUrl'

const ProfileHead = () => {
  const isMeRoute = useSelector<any, any>((state) => state.profile.getIn(['isMeRoute']))
  const profileUserInfo = useSelector<any, any>((state) => state.profile.getIn(['userInfo']))
  const userInfo = profileUserInfo.toJS().data
  const profileUserPosts = useSelector<any, any>((state) => state.profile.getIn(['userPosts']))
  const userPosts = profileUserPosts.toJS()

  // user => 有圖片顯示，沒圖片利用 mid 計算守護動物圖片
  const getUserPhotoUrl = () => {
    if (userInfo.photoUrl) return userInfo.photoUrl

    const animalIndex = userInfo.mid % 10
    const backgroundIndex = userInfo.mid % 12

    return `${AppUrlLib.appUrl}/statics/images/avatar/animal_${animalIndex}_${backgroundIndex}.jpg`
  }

  const currentUserImage = useSelector<any, any>((state) =>
    state.currentUser.getIn(['userInfo', 'img']),
  )
  const profileMeMeta = {
    title: '個人主頁｜PopDaily 波波黛莉',
    description: '首款 App 正式推出！吃喝玩樂熱門話題靈感即時掌握，天天都有好玩的事在這裡發生！',
    cover: `${AppUrlLib.appUrl}${currentUserImage}`,
  }

  const profileUserMeta = {
    title: `「${userInfo.name}」精選文章懶人包（持續更新！）｜PopDaily 波波黛莉`,
    description:
      `${userInfo.name} 的最新文章：` +
      userPosts.list
        .slice(0, 3)
        .map((p) => _.get(p, 'web.title', p.title))
        .join('、'),
    noIndex: !userPosts.list.length,
    cover: getUserPhotoUrl(),
  }

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: profileUserMeta.title,
    description: profileUserMeta.description,
    keywords: _.get(userPosts.list, '[0].hashTags', []).join(','),
    dateCreated: userInfo.createdAt,
    dateModified: userInfo.updatedAt,
    datePublished: userInfo.createdAt,
    primaryImageOfPage: {
      '@type': 'ImageObject',
      contentUrl: AppUrlLib.imageBaseUrl + '/' + _.get(userPosts.list, '[0].img[0].path') || '',
    },
  }

  const itemListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      (userPosts.list || []).slice(0, 7).map((p, index) => ({
        '@type': 'ListItem',
        name: _.get(p, 'web.title', p.title),
        image: AppUrlLib.imageBaseUrl + '/' + _.get(p, 'img[0].path') || '',
        url: AppUrlLib.appUrl + '/' + p.postID.split('.').join('/'),
        position: index + 1,
      })),
    ],
  }

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://www.popdaily.com.tw/',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
      },
      urlTemplate: 'https://www.popdaily.com.tw/search/{search_term_string}',
      'query-input': {
        '@type': 'PropertyValueSpecification',
      },
      valueRequired: 'http://schema.org/True',
      valueName: 'search_term_string',
    },
  }

  return (
    <>
      {isMeRoute ? (
        <Head>
          <link rel="canonical" href={`${AppUrlLib.appUrl}/user/me`} />
          <title key="title">{profileMeMeta.title}</title>
          <meta key="description" name="description" content={profileMeMeta.description} />
          <meta property="og:image" content={profileMeMeta.cover} />
          <meta property="og:title" content={profileMeMeta.title} />
          <meta property="og:description" content={profileMeMeta.description} />
        </Head>
      ) : (
        <Head>
          <link rel="canonical" href={`${AppUrlLib.appUrl}/user/${userInfo.mid}`} />
          <title key="title">{profileUserMeta.title}</title>
          <meta key="description" name="description" content={profileUserMeta.description} />
          <meta property="og:image" content={profileUserMeta.cover} />
          <meta property="og:title" content={profileUserMeta.cover} />
          <meta property="og:description" content={profileUserMeta.description} />
          {profileUserMeta.noIndex && <meta name="robots" content="noindex" />}
          {/* WebPage */}
          <script
            key="WebPage"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
          />
          {/* Website */}
          <script
            key="Website"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
          />
          {/* ItemList */}
          {userPosts.list.length && (
            <script
              key="ItemList"
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListSchema) }}
            />
          )}
        </Head>
      )}
    </>
  )
}

export default ProfileHead
